var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blob-content-viewer',{attrs:{"path":_vm.path,"project-path":_vm.projectPath}})}
var staticRenderFns = []

export { render, staticRenderFns }